import { ToastContainer as ReactToastifyContainer } from "react-toastify";
import styles from "./Toast.module.scss";

export function ToastContainer() {
  return (
    <ReactToastifyContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      toastClassName={styles.toast}
      bodyClassName={styles.toastBody}
      className={styles.toastContainer}
    />
  );
}